// GENERATED by the workspace box from this app’s own contract — never edit it, every sync rewrites it.
// Every kebab surface id the model places a moment on, sorted, and beside it the two facts the
// platform’s route guard reads: the role slugs each surface demands of a session, and whether a
// signed-out visitor may stand there at all. Both derived from the design, never authored.
//
// The two are NOT each other’s negative. An empty role list means no ROLE is demanded — which is
// true of a customer’s own screen as much as of the app’s front door — so the public fact is stated
// in its own right rather than inferred from an absence.
//
// This is one half of a join the platform makes: a journey’s read declares the screen it lives on as
// `moment.surface`, and a route declares the screen it renders as the `page` of its route-inventory
// entry. Take a contract screen’s `page` from here — `SURFACES['<id>']` — and the two are THE SAME
// VALUE rather than two spellings kept aligned by hand.

export const SURFACES = {
  "filing-facts": "filing-facts",
  "filing-setup": "filing-setup",
  "filing-submission": "filing-submission",
  "front-door": "front-door",
  "return-review": "return-review",
  "sign-in": "sign-in",
  "sign-up": "sign-up",
  "source-intake": "source-intake",
} as const;

export type SurfaceId = keyof typeof SURFACES;

export const SURFACE_ROLES: Readonly<Record<SurfaceId, readonly string[]>> = {
  "filing-facts": ["actor-cpa"],
  "filing-setup": ["actor-cpa"],
  "filing-submission": ["actor-cpa"],
  "front-door": [],
  "return-review": ["actor-cpa"],
  "sign-in": [],
  "sign-up": [],
  "source-intake": ["actor-cpa"],
};

export const SURFACE_PUBLIC: Readonly<Record<SurfaceId, boolean>> = {
  "filing-facts": false,
  "filing-setup": false,
  "filing-submission": false,
  "front-door": true,
  "return-review": false,
  "sign-in": true,
  "sign-up": true,
  "source-intake": false,
};
